import React, { useEffect, useState } from 'react';
import Empty from '../feedback/Empty';
import Loading from '../feedback/Loading';
import moment from 'moment';
import { GrAdd } from 'react-icons/gr';
import adminServices from '../../services/AdminServices';
import CategoryModal from './CategoriesModal';
import { FaCheck, FaX } from 'react-icons/fa6';

function DashboardCategories() {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [action, setAction] = useState(0);
    const [activeCategory, setActiveCategory] = useState(null);

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = () => {
        setLoading(true);
        adminServices.getCategories()
            .then(res => {
                setCategories(res.data || []);
                setLoading(false);
            })
            .catch(err => {
                console.error('Failed to fetch categories:', err);
                setLoading(false);
            });
    };

    const openModal = (actionType, category = null) => {
        setAction(actionType)
        const openBtn = document.getElementById('category-open-btn');
        if (actionType === 0) {
            openBtn.click()
            return
        }
        setActiveCategory(category)
        openBtn.click()
    };

    return (
        <div className='space-y-5'>
            <div className="flex md:items-end justify-between gap-4 items-center">
                <h3 className='text-xl font-bold'>
                    Categories{' '}
                    <span className='ml-2 text-gray-500'>
                        ({categories.length})
                    </span>
                </h3>
                <button
                    onClick={() => openModal(0)}
                    className="inline-flex items-center justify-center px-4 py-2 bg-primary hover:bg-sky-600 border border-transparent rounded-lg text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary shadow-sm transition-all"
                >
                    <GrAdd className='h-5 w-5 mr-2' />
                    Add New Category
                </button>
            </div>
            <CategoryModal
                action={action}
                activeCategory={activeCategory}
                onReload={fetchCategories}
                setActiveCategory={setActiveCategory}
            />
            <div>
                <div className="bg-surface-light dark:bg-surface-dark rounded-xl border border-border-light dark:border-border-dark overflow-hidden">
                    <div className='overflow-x-auto'>
                        <table className="table table-compact table-zebra w-full">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Services</th>
                                    <th>Shift Work</th>
                                    <th className='hidden md:table-cell'>Created</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {categories?.length ? (
                                    categories.map((category, idx) => (
                                        <tr key={category.id || idx}>
                                            <td className='font-bold'>{category?.name}</td>
                                            <td>{category?.service_count || 0}</td>
                                            <td>
                                                {category?.is_shift ? (
                                                    <FaCheck />
                                                ) : (
                                                    <FaX />
                                                )}
                                            </td>
                                            <td className='hidden md:table-cell font-bold'>
                                                {moment(category?.created_at).format('MMM Do YYYY')}
                                            </td>
                                            <td>
                                                <button
                                                    onClick={() => openModal(1, category)}
                                                    className='btn btn-sm btn-secondary'
                                                >
                                                    View
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : null}
                            </tbody>
                        </table>

                        {loading && <Loading />}
                        {!categories?.length && !loading && (
                            <div className="p-3">
                                <Empty objectName="Categories" />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashboardCategories;